/**
 * 描述：编辑租户
 * 日期：2017-11-7
 * 作者：liujinming
 */
"use strict";
angular.module("newCreateGroupModule", [])
    .controller("newCreateGroupCtrl", ["$scope", "$rootScope","$state", "$validation", "$timeout", "trsHttpService", "globleParamsSet", "commandService", "trsspliceString", "modalDialog", "$modalInstance", "item", function($scope,$rootScope, $state, $validation, $timeout, trsHttpService, globleParamsSet, commandService, trsspliceString, modalDialog, $modalInstance, item) {
        var vm = $scope.vm = {
            group: {
                Gname: '',
                SerialNumber: '',
            },
            getGroup: function() {
                return {
                    Gname: this.group.Gname,
                    status: $scope.status.status === true ? 0 : -1,
                    Approver: trsspliceString.filter($scope.itemsSd, 'USERID').join(','),
                    VisibleUser: trsspliceString.filter(visibleuser(), 'USERID').join(','),
                    SerialNumber: this.group.SerialNumber,
                    ChannelIds:$scope.status.selectedChannelId
                };
            },
            searchWord: '',
            userKey: ''
        };
        initStatus();
        /** [initStatus description]初始化状态 */
        function initStatus() {
            $scope.status = {
                status: true,
                isShowSP: true,
                isShowKJ: true,
                title: item === undefined ? "新建分组" : "编辑分组",
                searchWordSP: '',
                searchWordLJ: '',
                channels: [{ //发稿渠道
                    text: '客户端',
                    key: '1',
                }, {
                    text: '网站',
                    key: '2',
                }, {
                    text: '报纸',
                    key:'3',
                },{
                    text: '微博',
                    key: '7',
                },{
                    text: '微信',
                    key: '8',
                },{
                    text: '电视台',
                    key: '4',
                }, {
                    text: '广播',
                    key: '5',
                }, {
                    text: '其他',
                    key: '6',
                }],
                selectedArray:[],
                selectedChannelId:''
            };
            if (item != undefined) {
                $scope.vm.group.Gname = item.name;
                $scope.vm.group.SerialNumber = item.order;
                $scope.status.status = item.status;
            }

        }
        /**
         * [chooseChannel description] 选择发布媒体
         * @param  {[type]} pubWay  [description]  发布渠道
         * @param  {[type]} channel [description]  发布媒体
         * @return {[type]}         [description]
         */
        $scope.chooseChannel = function(item) {
            var index = $scope.status.selectedArray.indexOf(item.key.toString());
            if (index >= 0) {
                $scope.status.selectedArray.splice(index, 1);
            } else {
                $scope.status.selectedArray.push(item.key);
            }
        };
        /** [showSP description]展示审批人的 审批内容 */
        $scope.showSP = function() {
            $scope.status.isShowSP = true;
        };
        /** [showSP description]影藏审批人的人员列表 */
        $scope.hiddenSP = function() {
            $scope.status.isShowSP = false;
        };
        /** [showKJ description]显示可见范围的人员列表 */
        $scope.showKJ = function() {
            $scope.status.isShowKJ = true;
        };
        /** [showKJ description]隐藏可见范围的人员列表 */
        $scope.hiddenKJ = function() {
            $scope.status.isShowKJ = false;
        };

        function visibleuser() {
            var arr = [];
            angular.forEach($scope.rangeUserList, function(item) {
                var flag = true;
                angular.forEach($scope.itemsSd, function(approver) {
                    if (item.USERID === approver.USERID) {
                        flag = false;
                    }
                });
                if (flag) {
                    arr.push(item);
                }
            });
            return arr;
        }

        $scope.deleteApprover = function(approver) {
            var arr = [];
            angular.forEach($scope.rangeUserList, function(data, index, array) {
                if (data.USERID !== approver.USERID) {
                    arr.push(data);
                }
            });
            $scope.rangeUserList = arr;
        };
        $scope.saveGroup = function(form) {
            var selectChannelArray=angular.copy($scope.status.selectedArray);
            $scope.status.selectedChannelId=selectChannelArray.join(',');
            if(selectChannelArray<1){
                modalDialog.alertType("请确认发布渠道!", '', 'error', "confirm");
                return;
            }
            if ($scope.itemsSd.length != 0) {
                if (item === undefined) {
                    $validation.validate($scope.newCreateGroup).success(function() {
                        commandService.newInvoke('saveReportGroup', vm.getGroup()).then(function(data) {
                            if (data.ISSUCCESS === 'true') {
                                modalDialog.alertType('添加成功', '', 'success', false, function() {
                                    $rootScope.$broadcast("manaRefreshSummaryGroups");
                                    $modalInstance.close();
                                });
                            }
                        });
                    }).error(function() {
                        modalDialog.alertType("请确认分组信息!", '', 'error', "confirm");
                    });
                } else {
                    $validation.validate($scope.newCreateGroup).success(function() {
                        var params = vm.getGroup();
                        params.GroupId = item.id;
                        commandService.newInvoke('editReportGroup', params).then(function(data) {
                            if (data.ISSUCCESS === 'true') {
                                modalDialog.alertType('修改成功', '', 'success', false, function() {
                                    $rootScope.$broadcast("manaRefreshSummaryGroups");
                                    $modalInstance.close();
                                });
                            }
                        });
                    }).error(function() {
                        modalDialog.alertType("请确认分组信息!", '', 'error', "confirm");
                    });
                }
            }else {
                modalDialog.alertType("审批人不能为空!", '', 'error', "confirm");
            }

        };
        /**树组织的数据初始化在编辑状态下初始化选中列表数据*/
        init();

        $scope.checkSerialNumber = function() {
            if (vm.group.SerialNumber && vm.group.SerialNumber.toString().length > 0 && (vm.group.SerialNumber.toString().length > 10 || !/^[1-9][0-9]*$/.test(vm.group.SerialNumber))) {
                $scope.tipofindex = true;
            } else {
                $scope.tipofindex = false;
            }
        };
        /** [deleteSP description]删除审批人 */
        $scope.deleteSP = function(item) {
            var num = $scope.itemsSd.indexOf(item);
            if (num != -1) {
                $scope.itemsSd.splice(num, 1);
            }
        };
        /** [deleteSP description]删除可见范围 */
        $scope.deleteKJ = function(item) {
            var num = $scope.rangeUserList.indexOf(item);
            if (num != -1) {
                $scope.rangeUserList.splice(num, 1);
            }
        };

        function checkFormUsers() {
            if (vm.group.SerialNumber) {
                if (vm.group.SerialNumber.toString().length > 10 || !/^[1-9][0-9]*$/.test(vm.group.SerialNumber)) {
                    $scope.tipofindex = true;
                    return false;
                }
            }
            if ($scope.rangeUserList.length == 0) {
                modalDialog.alertType('审批人不能为空', '', 'info', false);
                return false;
            }
            return true;
        }
        /** [showSelected description]:审批人的树节点选择操作 */
        $scope.showSelected = function(node) {
            getGroupData(node);
        };
        /** [showToggle description]: 可见范围的树的节点选择操作 */
        $scope.showRangeSelected = function(node) {
            getGroupRangeData(node);
        };
        $scope.showToggle = function(node) {
            childrenTree(node, function() {});
        };
        /** [toRight description]审批人的选中右移添加操作 */
        $scope.toRight = function() {
            toRight($scope.toChooseUser);
        };
        /** [toRightRange description]可见范围的右移添加操作 */
        $scope.toRightRange = function() {
            toRightRange($scope.toChooseRangeUser);
        };
        $scope.toggleExpand = function() {
            $scope.isexpanded = !$scope.isexpanded;
        };
        /** [chooseUserName description]选择审批人 */
        $scope.chooseUserName = function(type, user) {
            if (type == "toChoose") {
                angular.forEach($scope.userDatas, function(data, index, array) {
                    $scope.userDatas[index].selected = "";
                });
                user.selected = "selected";
                $scope.toChooseUser = user;
            } else if (type == "cancelChoose") {
                angular.forEach($scope.itemsSd, function(data, index, array) {
                    $scope.itemsSd[index].selected = "";
                });
                user.selected = "selected";
                $scope.cancelChooseUser = user;
            }
        };
        /** [chooseRangeUserName description]选择可见范围用户 */
        $scope.chooseRangeUserName = function(type, user) {
            if (type == "toChoose") {
                angular.forEach($scope.rangeData, function(data, index, array) {
                    $scope.rangeData[index].selected = "";
                });
                user.selected = "selected";
                $scope.toChooseRangeUser = user;
            } else if (type == "cancelChoose") {
                angular.forEach($scope.rangeUserList, function(data, index, array) {
                    $scope.rangeUserList[index].selected = "";
                });
                user.selected = "selected";
                $scope.cancelChooseRangeUser = user;
            }
        };
        //输入过滤器
        $scope.myFilter = function(expected, actual) {
            var flag = true;
            if ($scope.status.searchWordSP !== "" && angular.isDefined($scope.status.searchWordSP)) {
                flag = expected.TRUENAME.indexOf($scope.status.searchWordSP) >= 0 ? true : false;
            }
            return flag;
        };
        $scope.myFilterKJ = function(expected, actual) {
            var flag = true;
            if ($scope.status.searchWordKJ !== "" && angular.isDefined($scope.status.searchWordKJ)) {
                flag = expected.TRUENAME.indexOf($scope.status.searchWordKJ) >= 0 ? true : false;
            }
            return flag;
        };
        //输入过滤器
        //双击选择开始
        $scope.directlyToRight = function(user) {
            toRight(user);
        };
        //双击选择结束
        //双击添加可见范围的人员
        $scope.directlyToRightRange = function(user) {
            toRightRange(user);
        };
        //双击取消选择开始
        $scope.directlyToLeft = function(user) {
            toLeft(user);
        };
        //双击取消选择结束
        //双击删除可见范围的选中人员
        $scope.directlyToLeftRange = function(user) {
            toLeftRange(user);
        };
        $scope.toLeft = function() {
            toLeft($scope.cancelChooseUser);
        };
        /**
         * [toLeftRange description]可见范围的选中删除操作
         * @return {[type]} [description] 删除时选中的人员
         */
        $scope.toLeftRange = function() {
            toLeftRange($scope.cancelChooseRangeUser);
        };

        function init() {
            //组织树配置文件
            $scope.treePAOptions = {
                nodeChildren: "CHILDREN",
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: "a1",
                    li: "a2",
                    liSelected: "a7",
                    iExpanded: "a3",
                    iCollapsed: "a4",
                    iLeaf: "a5",
                    label: "a6",
                    labelSelected: "a8"
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN == "false";
                },
                isSelectable: function(node) {
                    return node.PARENTID !== '0';
                }
            };
            $scope.expandedPA = angular.copy($scope.expandedTest);
            $scope.isexpanded = false;

            var treeParams = {
                "serviceid": "mlf_group",
                "methodname": "queryGroupTreeWithMyPath"
            };
            //获取没有权限的组织树
            trsHttpService.httpServer("/wcm/mlfcenter.do", treeParams, "get").then(function(data) {
                $scope.treedataPA = [data];
                ExpandedNodes();
            }, function(data) {});
            //初始化最近记录限制
            $scope.limitRecordNum = 10;
            //初始化审批人选择列表
            $scope.itemsSd = [];
            //初始化可见范围选择列表
            $scope.rangeUserList = [];
            if (item != undefined) {
                commandService.newInvoke('queryGroup', { GroupId: item.id }).then(function(res) {
                    var channels=res.CHANNEL,channelsArray=[];
                    angular.forEach(channels,function(v,key){
                        channelsArray.push(v.CHANNELID)
                    });
                    $scope.status.selectedArray=channelsArray;
                    vm.group.Gname = res.GNAME;
                    $scope.rangeUserList = res.VISIBLEUSER;
                    vm.group.SerialNumber = res.SERIALNUMBER;
                    $scope.itemsSd = res.APPROVER;
                });
            }

        }
        /** [cancelAll description]全部撤销 */
        $scope.cancelAll = function() {
            $scope.itemsSd = [];
        };
        /** [cancelRangeAll description] 可见范围全部撤销 */
        $scope.cancelRangeAll = function() {
            $scope.rangeUserList = [];
        };
        //默认展开树开始yao 
        function ExpandedNodes() {
            $scope.expandedPA = [];
            $scope.expandedPA.push($scope.treedataPA[0]);
            if ($scope.treedataPA[0].CHILDREN === 0) {
                $scope.selectedNodePA = $scope.treedataPA[0];
                $scope.selectedNodePK = $scope.treedataPA[0];
                getGroupData($scope.selectedNodePA);
                getGroupRangeData($scope.selectedNodePK);
            } else {
                angular.forEach($scope.treedataPA[0].CHILDREN, function(data, index, array) {
                    if (data.ISPATH === "true") {
                        if (data.CHILDREN.length !== 0) {
                            $scope.expandedPA.push(data);
                            selfPath(data);
                        } else {
                            $scope.selectedNodePA = data;
                            $scope.selectedNodePK = data;
                            getGroupData($scope.selectedNodePA);
                            getGroupRangeData($scope.selectedNodePK);
                        }
                    }
                });
            }
        }
        $scope.selectedAll = function() {
            angular.forEach($scope.userDatas, function(data, index, array) {
                delete data.selected;
                data.USERNAME = data.TRUENAME;
                data.deptId = $scope.groupObj.GROUPID;
                $scope.itemsSd = globleParamsSet.arrayContrast([angular.copy(data)], angular.copy($scope.itemsSd), "USERID", "OPERTYPE");
                $scope.userDatas[index].selected = "";
            });
        };
        //默认展开树结束
        /** [selectedAll description]:全选可见范围 */
        $scope.selectedRangeAll = function() {
            angular.forEach($scope.rangeData, function(data, index, array) {
                delete data.selected;
                data.USERNAME = data.TRUENAME;
                $scope.rangeUserList.push(data);
                $scope.rangeData[index].selected = "";
            });
        };

        function getGroupData(node) {
            $timeout(function() {
                    //此判断如果两次点击同一个树，不重复加载角色列表。
                    $scope.groupObj = node;
                    $scope.oldSelectNode = node;
                    $scope.Datas = [];
                    $scope.userData = null;
                    var params = {
                        "serviceid": "mlf_group",
                        "methodname": "getUsersByGroup",
                        "GroupId": $scope.groupObj.GROUPID
                    };
                    //trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        $scope.userDatas = data.map(function(user) {
                            return {
                                COMPANY: user.DEPT,
                                DEPT: user.DEPT,
                                ID: user.ID,
                                SUGGESTION: user.SUGGESTION,
                                TRUENAME: user.USERNAME,
                                USERID: user.ID
                            };
                        });
                    }, function(data) {
                        modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                    });
                },
                100);
        }
        /** [getGroupData description]:可见范围的节点点击操作 */
        function getGroupRangeData(node) {
            $timeout(function() {
                    //此判断如果两次点击同一个树，不重复加载角色列表。1111
                    $scope.groupObj = node;
                    $scope.oldSelectNode = node;
                    $scope.Datas = [];
                    $scope.rangeData = null;
                    var params = {
                        "serviceid": "mlf_group",
                        "methodname": "getUsersByGroup",
                        "GroupId": $scope.groupObj.GROUPID
                    };
                    //trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        $scope.rangeData = data.map(function(user) {
                            return {
                                COMPANY: user.DEPT,
                                DEPT: user.DEPT,
                                ID: user.ID,
                                SUGGESTION: user.SUGGESTION,
                                TRUENAME: user.USERNAME,
                                USERID: user.ID
                            };
                        });
                    }, function(data) {
                        modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                    });
                },
                100);
        }

        function selfPath(data) {
            for (var i = 0; i < data.CHILDREN.length; i++) {
                if (data.CHILDREN[i].ISPATH === "true") {
                    if (data.CHILDREN[i].HASCHILDREN === "false" || data.CHILDREN[i].CHILDREN.length === 0) {
                        $scope.selectedNodePA = data.CHILDREN[i];
                        getGroupData($scope.selectedNodePA);
                        getGroupRangeData($scope.selectedNodePA);
                        break;
                    } else {
                        $scope.expandedPA.push(data.CHILDREN[i]);
                        selfPath(data.CHILDREN[i]);
                        break;
                    }
                }
            }
        }

        function childrenTree(node, callback) {
            if (node.HASCHILDREN == "true" && node.CHILDREN.length === 0) {
                var paramsT = {
                    "serviceid": "mlf_group",
                    "methodname": "queryChildGroupsWithOutRight",
                    "GroupId": node.GROUPID
                };
                trsHttpService.httpServer("/wcm/mlfcenter.do", paramsT, "get").then(function(dataC) {
                        node.CHILDREN = dataC.CHILDREN;
                        callback();
                    },
                    function(dataC) {
                        modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                    });
            }
        }
        /** [toLeft description]审批人的选中移除 */
        function toLeft(item) {
            if (item !== "" && item !== undefined && $scope.itemsSd.indexOf(item) !== -1) {
                $scope.itemsSd.splice($scope.itemsSd.indexOf(item), 1);
                if (item.isSelected !== undefined) {
                    item.isSelected = false;
                }
                item.selected = false;
            }
            item = "";
        }
        /** [toRight description]审批人的右移假如选中裂变 */
        function toRight(toChooseUser) {
            toChooseUser = angular.copy(toChooseUser);
            toChooseUser.selected = "";
            toChooseUser.USERNAME = toChooseUser.TRUENAME;
            var flag = true;
            angular.forEach($scope.itemsSd, function(data, index, array) {
                if (data.USERID === toChooseUser.USERID) {
                    flag = false;
                }
            });
            if (flag) {
                $scope.itemsSd.push(toChooseUser);
            }
        }
        /** [toLeft description]可见范围的选中移除 */
        function toLeftRange(item) {
            if (item !== "" && item !== undefined && $scope.rangeUserList.indexOf(item) !== -1) {
                $scope.rangeUserList.splice($scope.rangeUserList.indexOf(item), 1);
                if (item.isSelected !== undefined) {
                    item.isSelected = false;
                }
                item.selected = false;
            }
            item = "";
        }
        /** [toRight description]可见范围的右移假如选中裂变 */
        function toRightRange(item) {
            item = angular.copy(item);
            item.selected = "";
            item.USERNAME = item.TRUENAME;
            var flag = true;
            angular.forEach($scope.rangeUserList, function(data, index, array) {
                if (data.USERID === item.USERID) {
                    flag = false;
                }
            });
            if (flag) {
                $scope.rangeUserList.push(item);
            }
        }
        /***/
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);